<script setup lang="ts">
import NavList from './NavList.vue';
import NavBottomSheet from './NavBottomSheet.vue';
import { type SupportItem } from '@composable/support';

defineProps<{
    title: string;
}>();
const emit = defineEmits<{
    close: [];
}>();

const navItems = useSupportList();
const onClick = (item: SupportItem) => {
    if (item.close) {
        emit('close');
    }
};
</script>

<template>
    <NavBottomSheet :title @close="emit('close')">
        <div>
            <img
                class="art-work"
                alt="support"
                src="/img/profile/support.png"
            />
        </div>
        <div class="column">
            <div class="column-content">
                <NavList
                    :nav-items="navItems.slice(0, 3)"
                    @item-select="onClick"
                />
            </div>
            <div class="column-content">
                <NavList
                    :nav-items="navItems.slice(3)"
                    @item-select="onClick"
                />
            </div>
        </div>
    </NavBottomSheet>
</template>

<style scoped lang="scss">
.column {
    display: flex;
    justify-content: center;
    gap: 24px;
    @include mobile-only {
        flex-direction: column;
        gap: 16px;
    }
    .column-content {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}
.art-work {
    width: 200px;
    height: 113px;
    margin-inline: auto;
}
</style>
